import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { CupomResponse, applyCupom } from "../services/onboarding";

const useCupom = (props?: UseMutationOptions<CupomResponse, Error, { codigo: string }, unknown>) => {
  return useMutation<CupomResponse, Error, { codigo: string }, unknown>({
    mutationKey: ["cupom"],
    mutationFn: ({ codigo }) => applyCupom(codigo),
    ...props,
  });
};

export { useCupom };
